import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
import ChartComponent from "../Chart/ChartComponent";
import Form from "../Form/Form";
import ProgressBar from "../ProgressBar/ProgressBar";

const API_URL = `${API_BASE_URL}/api/history/`;

function Historical() {
  const [historicalData, setHistoricalData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchInitialHistory() {
      try {
        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error(`Request failed: ${response.status}`);
        }

        setHistoricalData(await response.json());
      } catch (requestError) {
        setError(requestError.message);
      }
    }

    fetchInitialHistory();
  }, []);

  if (error) {
    return <p>Could not load historical data: {error}</p>;
  }

  if (!historicalData) {
    return <p>Loading historical data...</p>;
  }

  const historicalBars = [
    {
      canvasId: "progressCanvas4",
      value: historicalData.accuracy,
      minValue: historicalData.min_accuracy,
      maxValue: historicalData.max_accuracy,
      progressValueId: "progressValue4",
      minValueId: "minValue4",
      maxValueId: "maxValue4",
      barLabel: "ACCURACY",
    },
    {
      canvasId: "progressCanvas5",
      value: historicalData.profit,
      minValue: historicalData.min_profit,
      maxValue: historicalData.max_profit,
      progressValueId: "progressValue5",
      minValueId: "minValue5",
      maxValueId: "maxValue5",
      barLabel: "AVERAGE PROFIT",
    },
    {
      canvasId: "progressCanvas6",
      value: historicalData.agg_profit,
      minValue: historicalData.min_agg_profit,
      maxValue: historicalData.max_agg_profit,
      progressValueId: "progressValue6",
      minValueId: "minValue6",
      maxValueId: "maxValue6",
      barLabel: "AGGREGATE PROFIT",
    },
  ];

  return (
    <>
      <div className="h1-container">
        <h1>HISTORICAL DATA</h1>
      </div>

      <Form
        historicalData={historicalData}
        setHistoricalData={setHistoricalData}
      />

      <div className="progress-container">
        {historicalBars.map((item) => (
          <ProgressBar key={item.canvasId} {...item} />
        ))}
      </div>

      <ChartComponent
        dateList={historicalData.date_list}
        profitList={historicalData.profit_list}
      />
    </>
  );
}

export default Historical;
